import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldHalved, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { personalInfo } from "../data/portfolioData";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      style={{
        borderTop: "1px solid var(--border-subtle)",
        background: "var(--bg-primary)",
        padding: "48px 0 32px 0",
      }}
    >
      <div className="container">
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-4 pb-4 mb-4" style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.05)" }}>
          {/* Brand info */}
          <div>
            <div className="d-flex align-items-center gap-2 mb-1">
              <FontAwesomeIcon icon={faShieldHalved} style={{ color: "var(--accent)" }} />
              <span style={{ fontWeight: 700, fontSize: "1.1rem", color: "var(--text-primary)" }}>
                {personalInfo.name}
              </span>
            </div>
            <div className="font-mono text-muted" style={{ fontSize: "0.82rem" }}>
              Security Analyst • Cybersecurity • Security Operations
            </div>
          </div>

          {/* Quick navigation */}
          <div className="d-flex flex-wrap gap-4">
            <a href="#about" className="text-decoration-none text-muted" style={{ fontSize: "0.88rem" }}>
              About
            </a>
            <a href="#experience" className="text-decoration-none text-muted" style={{ fontSize: "0.88rem" }}>
              Experience
            </a>
            <a href="#projects" className="text-decoration-none text-muted" style={{ fontSize: "0.88rem" }}>
              Projects
            </a>
            <a href="#skills" className="text-decoration-none text-muted" style={{ fontSize: "0.88rem" }}>
              Skills
            </a>
            <a href="#contact" className="text-decoration-none text-muted" style={{ fontSize: "0.88rem" }}>
              Contact
            </a>
          </div>

          {/* Back to top */}
          <button
            type="button"
            onClick={scrollToTop}
            aria-label="Back to top"
            className="btn btn-sm btn-cyber-secondary font-mono"
            style={{ fontSize: "0.78rem", padding: "6px 14px" }}
          >
            <FontAwesomeIcon icon={faArrowUp} className="me-1" />
            Top
          </button>
        </div>

        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 font-mono text-muted" style={{ fontSize: "0.78rem" }}>
          <div>
            © 2026 {personalInfo.name}. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}

